/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PersonalAssetMetaDataDto,
    PersonalAssetMetaDataDtoFromJSON,
    PersonalAssetMetaDataDtoFromJSONTyped,
    PersonalAssetMetaDataDtoToJSON,
} from './PersonalAssetMetaDataDto';
import {
    PersonalAssetSpecialTypeEnum,
    PersonalAssetSpecialTypeEnumFromJSON,
    PersonalAssetSpecialTypeEnumFromJSONTyped,
    PersonalAssetSpecialTypeEnumToJSON,
} from './PersonalAssetSpecialTypeEnum';
import {
    PersonalAssetTypeEnum,
    PersonalAssetTypeEnumFromJSON,
    PersonalAssetTypeEnumFromJSONTyped,
    PersonalAssetTypeEnumToJSON,
} from './PersonalAssetTypeEnum';

/**
 * 
 * @export
 * @interface PersonalAssetDto
 */
export interface PersonalAssetDto {
    /**
     * 
     * @type {PersonalAssetTypeEnum}
     * @memberof PersonalAssetDto
     */
    type: PersonalAssetTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetSpecialTypeEnum}
     * @memberof PersonalAssetDto
     */
    sourceType: PersonalAssetSpecialTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetMetaDataDto}
     * @memberof PersonalAssetDto
     */
    metaData?: PersonalAssetMetaDataDto;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetDto
     */
    iconName: PersonalAssetDtoIconNameEnum;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetDto
     */
    colorName: PersonalAssetDtoColorNameEnum;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetDto
     */
    currencyCode: string;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetDto
     */
    lastUpdated: Date;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetDto
     */
    createdAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalAssetDto
     */
    deleted: boolean;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetDto
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetDto
     */
    portfolioId: string;
}

/**
* @export
* @enum {string}
*/
export enum PersonalAssetDtoIconNameEnum {
    Wallet = 'Wallet',
    WalletFilled = 'WalletFilled',
    Profits = 'Profits',
    ProfitsFilled = 'ProfitsFilled',
    Trades = 'Trades',
    TradesFilled = 'TradesFilled',
    Dividends = 'Dividends',
    DividendsFilled = 'DividendsFilled',
    AccountingDocument = 'AccountingDocument',
    Bell = 'Bell',
    BellFilled = 'BellFilled',
    ChartBar = 'ChartBar',
    HeartFilled = 'HeartFilled',
    Heart = 'Heart',
    CompoundInterest = 'CompoundInterest',
    ChartBarFilled = 'ChartBarFilled'
}/**
* @export
* @enum {string}
*/
export enum PersonalAssetDtoColorNameEnum {
    Blue = 'blue',
    BlueLight = 'blueLight',
    BlueDark = 'blueDark',
    Purple = 'purple',
    PurpleLight = 'purpleLight',
    PurpleDark = 'purpleDark',
    Green = 'green',
    GreenLight = 'greenLight',
    GreenDark = 'greenDark',
    Primary = 'primary',
    PrimaryLight = 'primaryLight',
    PrimaryDark = 'primaryDark',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    SecondaryDark = 'secondaryDark',
    Gray = 'gray',
    GrayLight = 'grayLight',
    GrayDark = 'grayDark',
    Orange = 'orange',
    OrangeLight = 'orangeLight',
    OrangeDark = 'orangeDark',
    Red = 'red',
    RedLight = 'redLight',
    RedDark = 'redDark',
    Pink = 'pink',
    PinkLight = 'pinkLight',
    PinkDark = 'pinkDark',
    Brown = 'brown',
    BrownLight = 'brownLight',
    BrownDark = 'brownDark',
    Yellow = 'yellow',
    YellowLight = 'yellowLight',
    YellowDark = 'yellowDark'
}

export function PersonalAssetDtoFromJSON(json: any): PersonalAssetDto {
    return PersonalAssetDtoFromJSONTyped(json, false);
}

export function PersonalAssetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PersonalAssetTypeEnumFromJSON(json['type']),
        'sourceType': PersonalAssetSpecialTypeEnumFromJSON(json['sourceType']),
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetMetaDataDtoFromJSON(json['metaData']),
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'id': json['id'],
        'name': json['name'],
        'currencyCode': json['currencyCode'],
        'lastUpdated': (new Date(json['lastUpdated'])),
        'createdAt': (new Date(json['createdAt'])),
        'deleted': json['deleted'],
        'order': json['order'],
        'portfolioId': json['portfolioId'],
    };
}

export function PersonalAssetDtoToJSON(value?: PersonalAssetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PersonalAssetTypeEnumToJSON(value.type),
        'sourceType': PersonalAssetSpecialTypeEnumToJSON(value.sourceType),
        'metaData': PersonalAssetMetaDataDtoToJSON(value.metaData),
        'iconName': value.iconName,
        'colorName': value.colorName,
        'id': value.id,
        'name': value.name,
        'currencyCode': value.currencyCode,
        'lastUpdated': (value.lastUpdated.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'deleted': value.deleted,
        'order': value.order,
        'portfolioId': value.portfolioId,
    };
}

